import styled from 'styled-components';
import React, { useState } from 'react';
import useSWR from 'swr';

import { fetcher } from '../utils';
import axios from 'axios';

const UnwagedList = ({ month }) => {

    const { data: unwageUserList } = useSWR( `/api/wage-processor/unwage-user-list?month=${month}`, fetcher, {
        revalidateOnReconnect: false, revalidateOnFocus: false
    });

    return (
        <StyledUnwagedList>
            <ul>
                { unwageUserList?.map(user =>
                    <li key={user.uuid}>
                        <div className="name">{ user.name }</div>
                    </li>
                )}
            </ul>
            
        </StyledUnwagedList>
    )
}

const StyledUnwagedList = styled.div`
    ul {

    }

    li {
        padding: 4px 0;
        font-size: 14px;
        font-weight: 700;
    }
`
export default UnwagedList